import React from 'react'

import {getEndOffset, useMarginRef} from '../../margin-provider'
import Postcard from '../postcard/Postcard'
import type {Props} from '../types'

const PostcardDesktop: React.FC<Props> = ({data}) => {
  const ref = useMarginRef<HTMLDivElement>(getEndOffset)

  return <Postcard data={data} ref={ref} />
}

export default PostcardDesktop
